import { render, staticRenderFns } from "./product.vue?vue&type=template&id=2ccab8ba&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=2ccab8ba&prod&lang=scss&scoped=true"
import style1 from "./product.vue?vue&type=style&index=1&id=2ccab8ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccab8ba",
  null
  
)

export default component.exports